import { useCallback, useRef } from 'react';

import { TooltipPosition } from './CursorTooltip.types';
import { calculateTooltipPosition, isValidPosition } from './tooltipHelpers';

export const usePositionUpdate = (
  tooltipRef: React.RefObject<HTMLDivElement>,
  maxWidth: number,
  offset: number,
  viewportPadding: number,
) => {
  const positionRef = useRef<TooltipPosition>({ x: 0, y: 0, width: maxWidth });

  const updatePosition = useCallback(
    (x: number, y: number) => {
      const position = calculateTooltipPosition(x, y, tooltipRef, {
        maxWidth,
        offset,
        viewportPadding,
      });

      if (!isValidPosition(position)) return null;

      positionRef.current = position;

      // Direct DOM manipulation for performance (avoids re-renders on every mouse move)
      if (tooltipRef.current) {
        tooltipRef.current.style.left = `${position.x}px`;
        tooltipRef.current.style.top = `${position.y}px`;
        tooltipRef.current.style.width = `${position.width}px`;
      }

      return position;
    },
    [tooltipRef, maxWidth, offset, viewportPadding],
  );

  return { positionRef, updatePosition };
};
